exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filters[data-v-4caebcc6]{margin-bottom:8px}.reports-grid[data-v-4caebcc6]{width:100%;height:calc(100vh - 320px)}", ""]);

// exports
